// ============================================================================
// ENTRADAS DE LA BITÁCORA — fuente única consumida por la página /bitacora
// (solo admin) y por el modal "Novedades en v{X}" (todos los usuarios).
//
// Para agregar una nueva entrada:
//   1) Subir APP_VERSION en frontend/src/version.js según SemVer.
//   2) Agregar el objeto al inicio de este array con la MISMA versión.
//
// Tipos: 'feat' (nueva funcionalidad), 'fix' (corrección), 'ui' (visual),
//        'perf' (rendimiento), 'chore' (mantenimiento técnico).
// ============================================================================

export const ENTRADAS = [
  // ─── v1.33.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.33.1',
    fecha: '2026-08-19',
    titulo: 'El periodo de evidencias termina en la Fecha de Diligenciamiento',
    tipo: 'fix',
    cambios: [
      'En el encabezado del formato de evidencias (GOR-F-012 V3), el rango "Correspondientes al periodo del 01 al …" ahora termina en el DÍA de la Fecha de Diligenciamiento de la cuenta (ej.: diligenciada el 12 de agosto → "del 01 al 12 de Agosto del 2026").',
      'Si la fecha de diligenciamiento es de otro mes o no se puede leer, se usa el último día del mes del informe (comportamiento anterior).',
      'Aplica al PDF de evidencias, a la parte de evidencias del GC y al Word de evidencias.',
    ],
  },
  // ─── v1.33.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.33.0',
    fecha: '2026-08-10',
    titulo: 'Fechas de certificaciones en el informe y nuevo encabezado del GOR-F-012 V3',
    tipo: 'feat',
    cambios: [
      'Cada certificación ahora tiene un campo "Expedida" para seleccionar su fecha de expedición al subirla. La validación exige la fecha (además del archivo) antes de generar el PDF.',
      'En el informe GC (PDF y Word), debajo de la tabla de desplazamientos, se imprime el texto "Para efectos del presente informe, se adjuntan las certificaciones de antecedentes..." con las 4 certificaciones y sus fechas en formato DD/MM/AAAA.',
      'La primera hoja del PDF de evidencias (GOR-F-012 V3) ahora lleva el encabezado oficial: PROCESO / GESTIÓN ORGANIZACIONAL Y DEL RIESGO / NOMBRE DEL FORMATO / PLANTILLA DOCUMENTOS Y FORMATOS EN WORD... / CLASIFICACIÓN DE LA INFORMACIÓN, seguido de "EVIDENCIAS DE LAS OBLIGACIONES CONTRATO No. X" y "Correspondientes al periodo del 01 al [último día] de [Mes] del [año]" (calculado automáticamente). También aplica al Word de evidencias.',
    ],
  },

  // ─── v1.32.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.32.1',
    fecha: '2026-08-10',
    titulo: 'La detección de cambios en evidencias ahora cubre eliminadas y movidas',
    tipo: 'fix',
    cambios: [
      'Al guardar, además de las evidencias nuevas, ahora también se detecta cuando ELIMINASTE o MOVISTE a otra obligación evidencias que ya estaban incluidas en las Acciones Realizadas — las acciones quedan desactualizadas y el aviso te lo indica por obligación.',
      'Al mover una evidencia se marcan las dos obligaciones: la de origen (evidencia eliminada/movida) y la de destino (evidencia nueva).',
      'Las opciones son las mismas: actualizar con IA y guardar, guardar sin actualizar, o cerrar y actualizarlas manualmente.',
    ],
  },

  // ─── v1.32.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.32.0',
    fecha: '2026-08-10',
    titulo: 'Detección de evidencias nuevas: acciones realizadas desactualizadas',
    tipo: 'feat',
    cambios: [
      'Si agregas evidencias nuevas a una obligación que YA tenía sus Acciones Realizadas escritas o generadas, al guardar la app lo detecta y te indica exactamente cuáles evidencias son nuevas (por obligación y número).',
      'Con IA habilitada: el aviso trae el botón "✨ Actualizar acciones con IA y guardar", que regenera las acciones incluyendo las evidencias nuevas y guarda de una vez (requiere que las evidencias nuevas tengan descripción).',
      'Sin IA (o si prefieres): puedes cerrar el aviso para actualizarlas manualmente, o "Guardar sin actualizar" si consideras que las acciones actuales siguen siendo válidas (no volverá a preguntar por esas mismas evidencias).',
      'Aplica en cuentas de cobro y post cuentas.',
    ],
  },

  // ─── v1.31.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.31.0',
    fecha: '2026-08-10',
    titulo: 'Eliminar de un clic las evidencias de otro mes',
    tipo: 'feat',
    cambios: [
      'El aviso de "Evidencias de otro mes" ahora trae el botón "🗑️ Eliminar las evidencias de otro mes": borra de un clic solo las evidencias con fecha anterior al mes de la cuenta o post cuenta (antes había que borrarlas una por una).',
      'Si una obligación queda sin imágenes tras la limpieza, sus "Acciones Realizadas" también se limpian (quedan en blanco); si le quedan evidencias válidas del mes, sus acciones se conservan.',
      'El mensaje del aviso ahora es más legible: lista por obligación en renglones separados y resume cuando son muchas.',
    ],
  },

  // ─── v1.30.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.30.0',
    fecha: '2026-08-10',
    titulo: 'Duplicar con o sin evidencias (a elección)',
    tipo: 'feat',
    cambios: [
      'Al duplicar una cuenta de cobro o post cuenta, ahora aparece una ventana que pregunta cómo duplicarla: "📎 CON evidencias" (copia todo tal cual) o "🆕 SIN evidencias" (las obligaciones quedan en blanco, sin evidencias ni acciones realizadas, listas para cargar las del nuevo mes).',
      'Duplicar sin evidencias evita tener que borrar una por una las del mes anterior.',
      'La copia sigue quedando de primera en la lista, resaltada con el efecto glow y con desplazamiento automático hasta ella, para entrar de una vez a ajustar el mes y las fechas.',
    ],
  },

  // ─── v1.29.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.29.0',
    fecha: '2026-08-10',
    titulo: 'Evidencias cargadas exigen Acciones Realizadas (con generación por IA al guardar)',
    tipo: 'feat',
    cambios: [
      'En cuentas de cobro y post cuentas: si una obligación tiene evidencias cargadas pero el campo "Acciones Realizadas" está vacío, ya no se puede guardar ni generar el PDF / vista previa.',
      'Si tienes la IA habilitada, al guardar aparece una ventana que ofrece "✨ Generar con IA y guardar": la app redacta las Acciones Realizadas de todas las obligaciones faltantes (a partir de las descripciones de sus evidencias) y guarda de una vez.',
      'Para usar esa generación, todas las evidencias de esas obligaciones deben tener descripción; si falta alguna, la app te indica cuáles describir (o puedes escribir las acciones manualmente).',
      'Si no tienes IA habilitada, el aviso te indica qué obligaciones necesitan que escribas las Acciones Realizadas manualmente.',
      'La misma validación aplica en el Dashboard: los botones de PDF y Vista Previa avisan si a la cuenta o post cuenta le faltan Acciones Realizadas.',
    ],
  },

  // ─── v1.28.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.28.0',
    fecha: '2026-08-09',
    titulo: 'Validación: no se genera el GC sin las 4 certificaciones cargadas',
    tipo: 'feat',
    cambios: [
      'Al generar el PDF del GC, abrir la Vista Previa o usar GC+IFPC (desde el editor o desde las tarjetas del Dashboard), la app ahora exige que estén cargadas las 4 certificaciones (fiscales, disciplinarios, penales y medidas correctivas). Si falta alguna, sale la ventana emergente indicando cuáles.',
      'Al guardar la cuenta NO se bloquea (puedes guardar borradores durante el mes), pero si faltan certificaciones aparece un recordatorio después de guardar, para que no se te olviden.',
      'Recuerda: las certificaciones van anexas al final del PDF, después de las evidencias (GOR-F-012 V3).',
    ],
  },

  // ─── v1.27.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.27.3',
    fecha: '2026-08-09',
    titulo: 'Los certificados se ven en el visor integrado',
    tipo: 'ui',
    cambios: [
      'El botón "👁️ Ver" de cada certificación ahora abre el visor integrado de vista previa (el mismo de los PDFs de la app) en vez de una pestaña nueva del navegador.',
      'Funciona tanto para certificados en PDF como en imagen, e incluye el botón Descargar con el nombre correcto del archivo.',
    ],
  },

  // ─── v1.27.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.27.2',
    fecha: '2026-08-09',
    titulo: 'Corregido el enlace de consulta de antecedentes disciplinarios',
    tipo: 'fix',
    cambios: [
      'El enlace de la certificación de antecedentes disciplinarios ahora lleva directo a la página de Consulta de Antecedentes de la Procuraduría (antes abría la página principal).',
    ],
  },

  // ─── v1.27.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.27.1',
    fecha: '2026-08-09',
    titulo: 'Certificaciones: vista previa y no se clonan al duplicar',
    tipo: 'ui',
    cambios: [
      'Cada certificación subida ahora tiene un botón "👁️ Ver" para consultar el PDF o la imagen antes de generar el informe.',
      'Al duplicar una cuenta, las certificaciones NO se copian: cada mes debes subir las certificaciones actualizadas con las fechas correspondientes (las de la cuenta original se conservan intactas en esa cuenta).',
    ],
  },

  // ─── v1.27.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.27.0',
    fecha: '2026-08-09',
    titulo: 'Certificaciones anexas al PDF y formato GCCON-F-087 V3',
    tipo: 'feat',
    cambios: [
      'El formato del Informe Mensual se actualizó de GCCON-F-087 V2 a GCCON-F-087 V3 (pie de página del PDF y del Word).',
      'Nueva sección "📜 Certificaciones" en el editor de cuentas de cobro: puedes adjuntar las 4 certificaciones (antecedentes fiscales, disciplinarios, penales y Registro Nacional de Medidas Correctivas) como PDF o imagen.',
      'Las certificaciones se anexan automáticamente al final del PDF generado, después de las evidencias (GOR-F-012 V3), en ese orden fijo. También quedan incluidas en la fusión GC+IFPC.',
      'Cada certificación tiene un enlace directo a la página oficial de consulta (Contraloría, Procuraduría, Policía Nacional y RNMC). Como esas páginas exigen verificación humana (captcha), el certificado se genera allá y se sube aquí (tip: Ctrl+P → «Guardar como PDF»).',
    ],
  },

  // ─── v1.26.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.26.0',
    fecha: '2026-06-12',
    titulo: 'Aviso: evidencias con fecha anterior al mes de la cuenta',
    tipo: 'feat',
    cambios: [
      'Al guardar (o generar PDF / abrir vista previa) una cuenta o post cuenta, ahora se valida que no haya evidencias cargadas ANTES del mes del informe.',
      'Caso típico: al duplicar una cuenta, las evidencias copiadas conservan la fecha de carga del mes pasado. Ahora aparece una ventana emergente que indica en qué obligación están y con qué fecha, para reemplazar la imagen o eliminarlas antes de guardar.',
      'Las evidencias cargadas en el mismo mes del informe, o después (cuando armas el informe al mes siguiente), NO se marcan.',
    ],
  },

  // ─── v1.25.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.25.3',
    fecha: '2026-06-12',
    titulo: 'Aviso emergente cuando falta imagen + bloqueo también de la vista previa',
    tipo: 'ui',
    cambios: [
      'El aviso de "texto sin imagen" ahora es una ventana emergente (más visible) que hay que aceptar, en vez de una notificación pequeña.',
      'Tampoco se puede abrir la Vista Previa si hay una obligación con texto pero sin imagen: muestra el mismo aviso indicando cuál corregir.',
    ],
  },

  // ─── v1.25.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.25.2',
    fecha: '2026-06-12',
    titulo: 'Subir varias imágenes a la vez (cada una como evidencia separada)',
    tipo: 'fix',
    cambios: [
      'Al usar "Subir Imágenes" (o arrastrar varias) ahora puedes seleccionar varias imágenes a la vez y cada una se agrega como una evidencia independiente.',
      'Antes, al elegir varias, solo quedaba una por un problema al agregarlas en secuencia; ahora se cargan todas juntas en una sola actualización.',
    ],
  },

  // ─── v1.25.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.25.1',
    fecha: '2026-06-12',
    titulo: 'El aviso de texto sin imagen ahora dice en cuál obligación está',
    tipo: 'ui',
    cambios: [
      'Cuando no se puede guardar por texto sin imagen, el aviso ahora indica claramente la obligación (número y título) y en qué parte está el texto (Acciones realizadas o descripción de evidencia), para saber exactamente dónde ir a corregir. Si son varias, lista sus números.',
    ],
  },

  // ─── v1.25.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.25.0',
    fecha: '2026-06-12',
    titulo: 'Evidencia obligatoria: no se permite texto sin imagen + texto por defecto en post cuentas',
    tipo: 'feat',
    cambios: [
      'Ya no se puede guardar (ni generar el PDF de) una cuenta o post cuenta si una obligación tiene texto (acciones realizadas o descripción de evidencia) pero NO tiene ninguna imagen cargada. Debes cargar al menos una imagen (con o sin descripción) o dejar la obligación sin texto. El aviso indica cuáles obligaciones corregir.',
      'En las post cuentas, cuando una obligación no tiene evidencia cargada, en el PDF ahora aparece el mismo texto que en las cuentas: "Para el periodo del informe no se ejecutaron acciones referentes el cumplimiento de esta obligación", tanto en la columna Acciones realizadas como en Evidencias.',
    ],
  },

  // ─── v1.24.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.24.2',
    fecha: '2026-06-12',
    titulo: 'Fix: el scroll del modal de usuario ya no mueve el fondo',
    tipo: 'fix',
    cambios: [
      'Con el modal de Crear/Editar usuario abierto, al hacer scroll fuera del recuadro se movía la página de fondo. Ahora el fondo queda bloqueado y todo el modal se desplaza igual por dentro que por fuera del recuadro.',
      'Funciona igual en computador y en móvil: el contenido de fondo no se mueve y siempre puedes llegar a los botones Crear/Cancelar desplazando el modal.',
    ],
  },

  // ─── v1.24.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.24.1',
    fecha: '2026-06-12',
    titulo: 'Fix: el modal de Crear/Editar usuario ya no oculta los botones',
    tipo: 'fix',
    cambios: [
      'En pantallas pequeñas, el modal de "Crear Usuario" / "Editar Usuario" crecía más que la pantalla y los botones "Crear" y "Cancelar" quedaban fuera de vista.',
      'Ahora el modal se limita al 90% del alto de la pantalla: el formulario hace scroll por dentro y los botones quedan fijos abajo, siempre visibles.',
    ],
  },

  // ─── v1.24.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.24.0',
    fecha: '2026-06-12',
    titulo: 'Gestión de pagos: editar, eliminar y tabla de pagos por usuario',
    tipo: 'feat',
    cambios: [
      'El administrador ahora puede EDITAR un pago (monto, fechas, método, referencia, notas) y ELIMINARLO definitivamente.',
      'En el panel de Pagos, la tabla "Pagos registrados en el mes" muestra el USUARIO al que pertenece cada pago, y cada fila es clickeable: abre el detalle del usuario para editar o eliminar sus pagos.',
      'Al editar, eliminar o anular un pago, la vigencia del usuario se recalcula automáticamente (puede subir o bajar según los pagos reales).',
    ],
  },

  // ─── v1.23.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.23.1',
    fecha: '2026-06-12',
    titulo: 'En Mi Perfil: tipo de licencia y mis pagos más claros',
    tipo: 'ui',
    cambios: [
      'En "Mi Perfil" → "Mi Estado de Pago" ahora se muestra el TIPO de licencia: "Prueba gratuita" o "Licencia por pago".',
      'La fecha de vigencia se etiqueta según el caso: "Prueba válida hasta…" para usuarios de prueba y "Licencia vigente hasta…" para quienes ya tienen pagos, con los días restantes.',
      'Se agregó la sección "Mis pagos realizados" donde cada usuario puede ver el historial de sus pagos (monto, periodo, fecha y método). Si no tiene pagos, se indica claramente.',
    ],
  },

  // ─── v1.23.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.23.0',
    fecha: '2026-06-12',
    titulo: 'Aviso de fin de prueba y bloqueo claro de licencias vencidas',
    tipo: 'feat',
    cambios: [
      'Los usuarios en periodo de prueba ahora reciben un aviso (ventana al iniciar sesión + banner fijo arriba) cuando les quedan 5 días o menos, indicando los días restantes y que deben comunicarse con el administrador para ampliar su licencia.',
      'El aviso desaparece automáticamente cuando el administrador registra un pago o amplía el periodo de prueba.',
      'Los usuarios cuya prueba o licencia ya venció no pueden iniciar sesión: ven un mensaje claro indicando que su licencia venció y que deben comunicarse con el administrador para seguir usando la aplicación.',
    ],
  },

  // ─── v1.22.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.22.0',
    fecha: '2026-06-12',
    titulo: 'Habilitar el uso de IA por usuario desde el panel de Usuarios',
    tipo: 'feat',
    cambios: [
      'En el panel de Usuarios (admin) hay una nueva columna "✨ IA" con un interruptor por usuario para habilitar o deshabilitar el uso de funciones de IA (como "Mejorar con IA").',
      'El botón "✨ Mejorar con IA" en las acciones realizadas ahora aparece para el administrador y para los usuarios que el admin haya habilitado. Los demás no lo ven.',
      'El administrador siempre puede usar la IA (aparece como "Siempre" en la columna).',
    ],
  },

  // ─── v1.21.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.21.2',
    fecha: '2026-06-12',
    titulo: 'Fix: el PDF fusionado se descargaba como "GC_JUNIO" en vez del nombre completo',
    tipo: 'fix',
    cambios: [
      'El archivo fusionado se descargaba como "GC_JUNIO.pdf" porque el navegador no recibía el nombre completo del servidor. Ahora el servidor expone ese dato y el archivo se descarga correctamente como GC_<cédula>_<rp>_<MES> (ej. GC_77094730_726_JUNIO.pdf).',
      'Como respaldo, si el navegador no pudiera leer el nombre, igual se arma con la cédula y el RP de tu configuración.',
    ],
  },

  // ─── v1.21.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.21.1',
    fecha: '2026-06-12',
    titulo: 'Fix fusión GC+IFPC firmado: permite archivos hasta 50 MB y nombre correcto',
    tipo: 'fix',
    cambios: [
      'Al subir el Informe Post Cuenta firmado salía "Archivo demasiado grande (máx 10 MB)" porque los PDF escaneados con firma pesan más. Ahora se permite hasta 50 MB para ese archivo.',
      'El PDF fusionado se descarga con la nomenclatura correcta GC_<cédula>_<rp>_<MES> (por ejemplo GC_77094730_726_JUNIO.pdf).',
    ],
  },

  // ─── v1.21.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.21.0',
    fecha: '2026-06-12',
    titulo: 'GC+IFPC: fusionar con el Informe Post Cuenta firmado por el supervisor',
    tipo: 'feat',
    cambios: [
      'El botón "GC+IFPC" de las tarjetas de cuentas de cobro ahora abre una ventana que te recuerda subir tu Informe Post Cuenta ya FIRMADO por el supervisor.',
      'Al subir ese PDF firmado y pulsar "Fusionar y descargar", IMEC genera la Cuenta de Cobro con sus evidencias y la une con el informe firmado que subiste, quedando el documento final firmado por ambas partes.',
      'La opción de la Vista Previa ("GC+IFPC") se conserva igual: sigue sirviendo para descargar la fusión automática aunque el informe todavía no esté firmado por el supervisor.',
    ],
  },

  // ─── v1.20.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.20.1',
    fecha: '2026-06-12',
    titulo: 'Fix: la cuenta duplicada ahora sí queda de primera',
    tipo: 'fix',
    cambios: [
      'Al duplicar, la copia a veces no quedaba de primera (p. ej. aparecía como #3 en vez de #8) por un desorden en la base: unas cuentas tenían la fecha de creación guardada como fecha y otras como texto, y eso confundía el ordenamiento.',
      'Ahora el listado de cuentas y post cuentas se ordena de forma consistente sin importar cómo esté guardada la fecha, así la cuenta más reciente (incluida la recién duplicada) siempre queda de primera con el número consecutivo.',
    ],
  },

  // ─── v1.20.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.20.0',
    fecha: '2026-06-12',
    titulo: 'Duplicar cuentas/post cuentas: clona todo, queda de primera y se resalta',
    tipo: 'feat',
    cambios: [
      'Al duplicar una cuenta de cobro o post cuenta, ahora se copian TODOS los datos (fechas, mes de cobro, planilla, período, viáticos, rango de evidencias y las obligaciones con sus evidencias). Ya no quedan campos vacíos: solo entras a ajustar lo que necesites.',
      'La cuenta duplicada queda de PRIMERA en la lista y con el número consecutivo al último (si la última era la 6, la nueva queda como la 7). Antes quedaba al final como #1 y con "fecha inválida".',
      'La nueva tarjeta se resalta con un efecto glow y la pantalla se desplaza automáticamente hasta ella, para que veas de inmediato cuál se agregó y entres a editarla.',
      'La copia queda como borrador y desbloqueada, lista para editar.',
    ],
  },

  // ─── v1.19.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.19.3',
    fecha: '2026-06-12',
    titulo: 'Modelos Flash-Lite (económicos) en el selector y mensajes de error de IA más claros',
    tipo: 'fix',
    cambios: [
      'El selector de modelos de Gemini ahora también muestra los modelos Flash-Lite, que son los más livianos y económicos (antes se ocultaban). Nota: Gemini no tiene modelos "mini" como otros proveedores; sus modelos económicos se llaman "Flash" y "Flash-Lite".',
      'Cuando Gemini rechaza el acceso (error 403 PERMISSION_DENIED), tanto en "Probar conexión" como en "Mejorar con IA" ahora se muestra un mensaje en español explicando qué hacer: generar una nueva API key en Google AI Studio y verificar el proyecto.',
    ],
  },

  // ─── v1.19.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.19.2',
    fecha: '2026-06-12',
    titulo: 'Cerrar la vista previa de evidencia con la tecla Escape',
    tipo: 'ui',
    cambios: [
      'Cuando abres una evidencia en vista previa (clic en la imagen), ahora puedes cerrarla presionando la tecla Escape, además del botón ✕.',
    ],
  },

  // ─── v1.19.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.19.1',
    fecha: '2026-06-12',
    titulo: 'Mejora con IA de Acciones Realizadas: ahora en una ventana para revisar e importar',
    tipo: 'feat',
    cambios: [
      'El botón "✨ Mejorar con IA" ahora está disponible solo para el administrador.',
      'Si ya hay texto en Acciones Realizadas, la IA mejora la redacción conservando el significado; si está vacío, lo redacta a partir de las descripciones de las evidencias.',
      'El resultado se muestra en una ventana emergente: puedes ver el texto actual, editar la propuesta de la IA a mano, regenerarla, y luego decidir si la "Importas al recuadro" u "Omites". Nada cambia en el recuadro hasta que tú lo importes.',
    ],
  },

  // ─── v1.19.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.19.0',
    fecha: '2026-06-12',
    titulo: 'Botón "✨ Mejorar con IA" para las Acciones Realizadas',
    tipo: 'feat',
    cambios: [
      'En cada obligación, junto a "Acciones Realizadas", hay un nuevo botón "✨ Mejorar con IA".',
      'La IA toma las descripciones de las evidencias de esa obligación (y el borrador actual, si lo hay) y redacta un texto profesional de las acciones realizadas, que es el resumen/explicación de las evidencias.',
      'La IA solo redacta a partir de lo que tú aportaste: no inventa hechos, cifras, fechas ni nombres. Si la información es escasa, redacta algo breve y general.',
      'El texto generado reemplaza el del recuadro para que lo revises antes de guardar. Requiere que el administrador haya configurado la IA en "Sistema (IA)".',
    ],
  },

  // ─── v1.18.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.18.0',
    fecha: '2026-06-12',
    titulo: 'Pegar imagen (Ctrl+V) en la obligación expandida la carga como evidencia',
    tipo: 'feat',
    cambios: [
      'Ahora, si tienes una obligación desplegada/expandida y pegas una imagen del portapapeles con Ctrl+V, se carga directamente como evidencia de esa obligación — ya no necesitas hacer clic dentro del recuadro primero.',
      'Funciona pegando en cualquier parte mientras la obligación esté abierta. Pegar texto dentro de los campos sigue funcionando normal (solo las imágenes se cargan como evidencia).',
    ],
  },

  // ─── v1.17.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.17.1',
    fecha: '2026-06-12',
    titulo: 'PDF de evidencias: imágenes más grandes, sin "Evidencias:" duplicado y más compacto',
    tipo: 'fix',
    cambios: [
      'Se quitó el encabezado "Evidencias:" que aparecía (a veces duplicado) antes de la lista. Ahora solo se ve "Evidencia 1:", "Evidencia 2:", etc. Si el texto de Acciones Realizadas traía un "Evidencias:" colgado al final (quedaba al importar datos), se limpia automáticamente.',
      'Los márgenes izquierdo y derecho del PDF de evidencias se ajustaron (de 1.5 cm a 1.0 cm) para que las imágenes puedan ser más grandes y aprovechen el ancho de la hoja.',
      'Cuando una obligación tiene una sola evidencia, la imagen ahora se muestra grande aprovechando el espacio de la hoja, en lugar de quedar pequeña.',
      'Se redujo el interlineado y el espacio entre el título de la obligación, las acciones realizadas y las evidencias, y el espacio entre el texto "Evidencia N:" y su imagen quedó al mínimo — todo más compacto.',
    ],
  },

  // ─── v1.17.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.17.0',
    fecha: '2026-06-12',
    titulo: 'Descripción de evidencia opcional + segundo botón para subir abajo',
    tipo: 'feat',
    cambios: [
      'La descripción de cada evidencia ahora es opcional. Por defecto aparece un botón "📝 Agregar descripción" y el cuadro de texto solo se muestra si lo abres (o si la evidencia ya traía descripción guardada). Puedes quitarla con "✕ Quitar descripción".',
      'En el PDF y el Word, las evidencias sin descripción igual muestran su número (ej. "Evidencia 3:"), solo sin texto adicional — así la numeración se mantiene ordenada.',
      'Se agregó un segundo cuadro para subir / arrastrar / pegar imágenes DEBAJO de la lista de evidencias. Así, cuando una obligación tiene muchas evidencias, no tienes que volver a subir hasta el botón de arriba después de cargar una nueva.',
    ],
  },

  // ─── v1.16.4 ──────────────────────────────────────────────────────────────
  {
    version: '1.16.4',
    fecha: '2026-06-11',
    titulo: 'PDF de evidencias: menos hojas y sin "Evidencia N:" huérfanas',
    tipo: 'fix',
    cambios: [
      'Antes, en el PDF de evidencias quedaba a veces la palabra "Evidencia N:" sola al pie de una hoja y su imagen saltaba a la hoja siguiente. Ahora la etiqueta y su imagen viajan siempre juntas (bloque que no se parte entre páginas).',
      'Antes quedaba una sola evidencia por hoja con mucho espacio en blanco, generando demasiadas páginas. La causa: el generador de PDF ignoraba el límite de tamaño de las imágenes y las ponía a tamaño completo (una foto llenaba casi una hoja).',
      'Ahora cada imagen se escala correctamente (máx. ~500px de ancho × 450px de alto, conservando la proporción), de modo que caben 2 evidencias por hoja cuando son capturas de correos. En pruebas, un informe de 6 correos pasó de 6 hojas a 3.',
      'Se redujo el margen inferior (de 2.5cm a 1.8cm) para aprovechar más espacio vertical; los códigos del formato (GOR-F-012 V3 / Folio) se mantienen bien abajo sin solaparse.',
      'En la Post Cuenta, el alto máximo de las imágenes bajó de 6" a 4.5" para que también quepan ~2 por hoja.',
    ],
  },

  // ─── v1.16.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.16.3',
    fecha: '2026-06-11',
    titulo: 'Fix: Vista Previa de Post Cuenta arranca generando el PDF directo',
    tipo: 'fix',
    cambios: [
      'En las Post Cuentas, al hacer clic en "Vista Previa" el modal se quedaba vacío con "Elige qué documento quieres ver", porque la barra de tabs solo se mostraba si había más de uno (y las Post Cuentas tienen un solo PDF: IFPC).',
      'Ahora, cuando el modal abre con un único tab, lo selecciona automáticamente y empieza a generar el PDF de inmediato — sin estado intermedio que pedirle "elegir".',
      'En las Cuentas de Cobro (3 tabs: GC / Solo Evidencias / GC+IFPC) el comportamiento sigue igual: el modal arranca vacío para que tú elijas qué quieres ver.',
    ],
  },

  // ─── v1.16.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.16.2',
    fecha: '2026-06-11',
    titulo: 'Fix definitivo: nada de autoguardado al abrir el editor',
    tipo: 'fix',
    cambios: [
      'En v1.16.1 el autoguardado al abrir aún se disparaba en algunos casos por un problema de orden de los useEffects de React (el "flipper" del flag de carga corría antes que el tracking de cambios y le ganaba la carrera).',
      'Ahora el orden está fijado de forma robusta: primero corren el tracking y el autoguardado (que ven el flag en falso y retornan), y al final corre el flipper que pone el flag en verdadero.',
      'Resultado: al abrir cualquier cuenta o post cuenta, el botón "Vista Previa" sale activo desde el inicio. Solo cuando hagas un cambio real, el sistema marca cambios pendientes y autoguarda a los 2 segundos.',
    ],
  },

  // ─── v1.16.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.16.1',
    fecha: '2026-06-11',
    titulo: 'Fix: ya no autoguarda al abrir el editor y arregla "Cargando datos..." al volver',
    tipo: 'fix',
    cambios: [
      'Antes, al abrir una cuenta o post cuenta para editar, el sistema disparaba un autoguardado innecesario aunque no hubieras tocado nada (porque los setState del cargado activaban el efecto de cambios).',
      'Ahora el tracking de cambios y el autoguardado se habilitan solo después de que la carga inicial termina. Si no haces cambios, no se autoguarda.',
      'Esto también arregla el caso de "Cargando datos..." infinito al hacer clic en "Volver al Dashboard": ya no había un PUT en cola compitiendo con los GETs del dashboard.',
      'El botón "Vista Previa" ahora aparece activo desde el inicio (si no hay cambios pendientes), no gris.',
    ],
  },

  // ─── v1.16.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.16.0',
    fecha: '2026-06-11',
    titulo: 'Autoguardado de evidencias y botón "Vista Previa" en el editor',
    tipo: 'feat',
    cambios: [
      'Las evidencias ahora se autoguardan a medida que escribes la descripción. Ya no tienes que hacer clic en el botón gris "Guardar Cambios" dentro de cada evidencia — ese botón fue retirado.',
      'El sistema de autoguardado global de la cuenta sigue persistiendo todo a Mongo cada ~2 segundos, así que ninguna evidencia se queda sin guardar.',
      'Nuevo botón "👁️ Vista Previa" en la barra inferior del editor de Cuentas de Cobro y Post Cuentas — queda entre "Guardar Cambios" y "Volver al Dashboard".',
      'El botón Vista Previa solo se activa cuando todos los cambios están guardados. Si tienes cambios pendientes, el botón se ve gris y al hacerle clic muestra: "Primero debes guardar la cuenta antes de ver la vista previa".',
      'Una vez activo, abre el mismo modal de Vista Previa del Dashboard: en Cuentas con tabs GC a PDF / Solo Evidencias / GC+IFPC; en Post Cuentas con IFPC a PDF.',
    ],
  },

  // ─── v1.15.4 ──────────────────────────────────────────────────────────────
  {
    version: '1.15.4',
    fecha: '2026-06-10',
    titulo: 'Glow en el botón Descargar al terminar la vista previa',
    tipo: 'ui',
    cambios: [
      'Cuando termina de generarse el PDF en el modal de vista previa, el botón "Descargar" del header se resalta con un glow esmeralda pulsante durante ~4 segundos.',
      'Evita que el usuario use el botón de descarga del visor de PDF interno (que guarda con un nombre genérico tipo UUID en lugar del nombre correcto IMEC).',
      'Tooltip extra: "⬇️ Descarga aquí para conservar el nombre correcto del archivo".',
    ],
  },

  // ─── v1.15.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.15.3',
    fecha: '2026-06-10',
    titulo: 'Barra de progreso con porcentaje al generar PDF',
    tipo: 'ui',
    cambios: [
      'En lugar del spinner circular solitario, ahora se muestra una barra de progreso azul con porcentaje (0-100%) mientras se genera el PDF.',
      'La barra avanza con curva ease-out (rápida al inicio, suave al final) hasta 95%, y salta a 100% cuando el PDF termina de cargarse de verdad.',
      'IMEC aprende: cada vez que generas un PDF guarda cuánto tardó en localStorage. La próxima vez la velocidad de la barra es más precisa para ese tipo de documento.',
      'Cuando se acerca al 95% aparece el mensaje "terminando los últimos detalles..." para que sepas que está en la fase final.',
    ],
  },

  // ─── v1.15.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.15.2',
    fecha: '2026-06-10',
    titulo: 'Vista previa: tú decides qué PDF generar',
    tipo: 'ui',
    cambios: [
      'Antes, al hacer clic en "Vista Previa" la app empezaba a generar el PDF del GC automáticamente, aunque tú quisieras ver "Solo Evidencias" o "GC+IFPC".',
      'Ahora el modal abre vacío con un mensaje: "Elige qué documento quieres ver". Solo se genera el PDF que tú selecciones haciendo clic en uno de los 3 botones (GC a PDF / Solo Evidencias / GC+IFPC).',
      'Beneficio: ya no se gastan recursos generando un PDF que no necesitas.',
    ],
  },

  // ─── v1.15.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.15.1',
    fecha: '2026-06-10',
    titulo: 'Tarjetas del Dashboard sin los botones de Word',
    tipo: 'ui',
    cambios: [
      'Se quitaron los botones "GC a Word", "Evid. Word" y "Word" (Post Cuenta) de las tarjetas del Dashboard porque en la práctica no se estaban usando.',
      'Las tarjetas quedan más limpias enfocadas en las exportaciones a PDF.',
      'Los endpoints backend de Word se mantienen funcionales por si en el futuro se vuelven a habilitar.',
    ],
  },

  // ─── v1.15.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.15.0',
    fecha: '2026-06-10',
    titulo: 'Limpieza automática de PDFs y Word generados',
    tipo: 'feat',
    cambios: [
      'Los PDFs y Word generados se acumulaban indefinidamente en el volumen de Railway aunque ya no se usaran.',
      'Nuevo cron interno corre cada 24 horas y borra automáticamente: (1) archivos huérfanos (cuya cuenta/post-cuenta ya no existe ni en activos ni en papelera) y (2) archivos con más de 90 días sin regenerarse.',
      'Nueva pestaña "💾 Almacenamiento" en Configuraciones del Sistema (solo admin) que muestra: cantidad total de PDFs y Word, espacio ocupado, cuántos son huérfanos o antiguos y un botón para limpiar manualmente cuando quieras.',
      'Los datos siempre quedan en la base de datos. Si necesitas un PDF/Word que se limpió, basta con regenerarlo desde su tarjeta en el Dashboard.',
    ],
  },

  // ─── v1.14.5 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.5',
    fecha: '2026-06-10',
    titulo: 'Eliminada la lentitud al crear o ver usuarios (fix N+1)',
    tipo: 'perf',
    cambios: [
      'La app se ralentizaba al crear o gestionar usuarios porque el endpoint que pinta los badges de pago (🟢🟡🔴🆓) hacía 2 queries por cada usuario (con 15 usuarios = ~30 queries por refresh, y se refrescaba cada 30s).',
      'Ahora ese endpoint hace solo 2 queries totales (usuarios + pagos) y agrupa en memoria. De ~1-3s a ~50-100ms por refresh.',
      'Mismo fix aplicado al dashboard de pagos (conteo de estados y morosos).',
      'El polling de estados de pago en la lista de usuarios pasó de 30s a 2 min (la lista de "En línea" sigue refrescando cada 30s).',
      'Resultado: crear o ver usuarios ya no congela la app.',
    ],
  },

  // ─── v1.14.4 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.4',
    fecha: '2026-05-15',
    titulo: 'Sugerencia "arrastra aquí" a ambos lados de los botones',
    tipo: 'ui',
    cambios: [
      'El texto "arrastra imágenes aquí" ahora aparece a ambos lados de los botones (izquierda y derecha) con flechas apuntando a los botones, reforzando que toda el área del recuadro es zona de drop.',
    ],
  },

  // ─── v1.14.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.3',
    fecha: '2026-05-15',
    titulo: 'Dropzone de evidencias más grande con sugerencia al lado',
    tipo: 'ui',
    cambios: [
      'El recuadro punteado para arrastrar imágenes ahora es más grande (padding vertical aumentado), más fácil de apuntar al arrastrar archivos.',
      'Cuando ya hay evidencias, al lado de los botones aparece un texto sutil "⬅ o arrastra imágenes aquí" en gris opaco para que recuerdes la opción sin saturar la UI.',
      'Hover ligero (borde gris más oscuro) sobre el área para reforzar que es interactiva.',
      'Bordes con esquinas más redondeadas (rounded-xl).',
    ],
  },

  // ─── v1.14.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.2',
    fecha: '2026-05-15',
    titulo: 'Efecto glow al arrastrar imágenes al cuadro de evidencias',
    tipo: 'ui',
    cambios: [
      'Cuando arrastras una imagen sobre el cuadro de evidencias, ahora se ilumina con un glow esmeralda pulsante: borde verde, ring de 4px, sombra difusa, y un leve scale.',
      'Aparece un cartel central blanco con animación bounce que dice "📥 ¡Suelta para subir!" para que sepas exactamente dónde soltar la imagen.',
      'Imposible no darse cuenta cuando el área está activa.',
    ],
  },

  // ─── v1.14.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.1',
    fecha: '2026-05-15',
    titulo: 'Botones "Subir Imágenes" y "Pegar" del mismo tamaño',
    tipo: 'ui',
    cambios: [
      'El botón "Pegar" se veía más alto y más ancho que "Subir Imágenes" porque el badge "Ctrl+V" sumaba altura.',
      'Ahora ambos botones tienen altura fija (h-10), ancho mínimo igual (170px) y el contenido centrado. El badge "Ctrl+V" tiene leading-none para no inflar el alto.',
    ],
  },

  // ─── v1.14.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.14.0',
    fecha: '2026-05-15',
    titulo: 'Pegar evidencias con un botón + scroll y glow a la nueva',
    tipo: 'ui',
    cambios: [
      'En desktop, junto al botón "Subir Imágenes" ahora hay un botón morado "📋 Pegar" con el atajo Ctrl+V visible: lee directamente el portapapeles y sube la imagen copiada sin que tengas que hacer clic en el área antes.',
      'Cuando subes, arrastras o pegas una evidencia nueva, la app hace scroll automático suave hasta ella y la resalta con un glow verde durante ~3 segundos. Imposible perderla.',
      'Aplica a todas las formas de agregar evidencia: Subir Imágenes, 📋 Pegar, Ctrl+V, Tomar Foto (móvil) y arrastrar archivos.',
      'El toggle "🕐 Con fecha/hora" también se aplica cuando se pega desde el botón.',
    ],
  },

  // ─── v1.13.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.13.2',
    fecha: '2026-05-15',
    titulo: 'Scrollbar horizontal flotante en gestión de usuarios',
    tipo: 'ui',
    cambios: [
      'La tabla de usuarios ahora tiene un scrollbar horizontal flotante encima del encabezado, sincronizado con el scroll de la tabla, para que puedas mover columnas horizontalmente sin bajar a buscar la barra.',
      'Los encabezados de columna quedan fijos (sticky) cuando se hace scroll vertical: siempre sabes a qué columna pertenece cada dato.',
      'La tabla tiene altura máxima 70% de pantalla con scroll vertical interno, lo que mantiene el scroll horizontal siempre visible.',
      'El scrollbar flotante solo aparece cuando realmente hace falta (la tabla es más ancha que la pantalla).',
    ],
  },

  // ─── v1.13.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.13.1',
    fecha: '2026-05-15',
    titulo: 'Vigencia administrativa se auto-extiende con prueba o pagos',
    tipo: 'fix',
    cambios: [
      'Antes: si dabas un periodo de prueba o registrabas un pago que pasara la vigencia administrativa del usuario (vigencia_fin), el sistema lo expulsaba con "Tu cuenta ha expirado" antes de que termine la prueba/pago.',
      'Ahora: al asignar prueba o registrar pago, IMEC extiende automáticamente vigencia_fin para que cubra al menos esa fecha. Cero conflicto entre los tres sistemas (vigencia administrativa, prueba y pagos).',
      'Solo extiende hacia arriba: nunca acorta una vigencia que ya tenías.',
      'Aplica al crear usuario, editar usuario y registrar pago.',
    ],
  },

  // ─── v1.13.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.13.0',
    fecha: '2026-05-15',
    titulo: 'Periodo de prueba gratis para enganchar usuarios',
    tipo: 'feat',
    cambios: [
      'Al crear o editar un usuario hay un nuevo toggle "🆓 Otorgar periodo de prueba gratis" con date picker y atajos rápidos (+7d, +15d, +30d, +60d).',
      'Mientras está en prueba, el usuario aparece como 🆓 En prueba (no como moroso) y puede usar la app normalmente.',
      'Cuando le registras el primer pago, el sistema sale del modo prueba automáticamente y pasa al flujo normal de vigencias.',
      'Si el periodo de prueba vence sin pago, el usuario queda como ⏰ Prueba vencida y se bloquea con un mensaje específico: "¿Te gustó la app? Contacta al administrador para registrar tu primer pago."',
      'El usuario ve en su perfil un aviso especial mientras está en prueba con la fecha hasta cuando es gratis y un recordatorio amable para pagar si le gusta.',
      'Dashboard de pagos actualizado con conteo de 🆓 En prueba y ⏰ Prueba vencida.',
    ],
  },

  // ─── v1.12.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.12.0',
    fecha: '2026-05-15',
    titulo: 'Control de pagos / mensualidad de usuarios',
    tipo: 'feat',
    cambios: [
      'Nueva columna "💰 Pago" en gestión de usuarios con badge de estado: 🟢 Al día / 🟡 Por vencer / 🔴 Vencido / ⚪ Sin pagos.',
      'Botón 💰 en cada usuario abre un modal para registrar pagos: monto, periodo (fechas específicas), método (Nequi, Transferencia, etc.), referencia y notas. Histórico completo con opción de anular pagos.',
      'Nueva pestaña "💰 Pagos" en Configuraciones (solo admin): dashboard con ingresos del mes, total histórico, conteo de usuarios por estado, lista de morosos y tabla de pagos del mes.',
      'Cada usuario ve su estado de pago en su Perfil: estado, vigencia hasta, total pagado e histórico.',
      'Bloqueo automático: si el pago vence, el usuario queda deshabilitado con un mensaje claro pidiendo contactar al administrador. Puede cerrar sesión y revisar su histórico, nada más.',
      'Admins nunca se bloquean. En modo soporte tampoco aplica.',
    ],
  },

  // ─── v1.11.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.11.0',
    fecha: '2026-05-15',
    titulo: 'Importar Datos de Contrato: drag & drop + IA por defecto',
    tipo: 'feat',
    cambios: [
      'Ahora puedes arrastrar un PDF directamente sobre la zona de carga del modal (antes solo aceptaba clic).',
      'La zona da feedback visual: borde azul resaltado mientras se arrastra y check verde cuando se acepta el archivo.',
      'La extracción ahora usa IA (Google Gemini) por defecto porque entrega datos mucho más precisos.',
      'Si la IA no está configurada o falla puntualmente, IMEC cae automáticamente al parser básico sin que el usuario tenga que hacer nada.',
      'El paso de revisión muestra qué motor se usó (✨ IA o 🔧 parser básico) y el botón "Mejorar con IA" ya solo aparece cuando tiene sentido (extracción hecha con parser).',
    ],
  },

  // ─── v1.10.8 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.8',
    fecha: '2026-05-15',
    titulo: 'Botón "Importar Datos de Contrato"',
    tipo: 'ui',
    cambios: [
      'En Configuración, el botón "📄 Importar desde PDF" ahora se llama "📄 Importar Datos de Contrato" — describe mejor para qué sirve.',
    ],
  },

  // ─── v1.10.7 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.7',
    fecha: '2026-05-15',
    titulo: 'Importar PDF: solo se analizan las primeras 4 páginas',
    tipo: 'perf',
    cambios: [
      'En un GC del SENA toda la información clave (contratista, supervisor, contrato, objeto, valor, plazo, obligaciones, firmas) está en las primeras 4 páginas; el resto son evidencias adjuntas que pueden ser decenas o cientos de páginas.',
      'Ahora la extracción (parser heurístico y "Mejorar con IA") procesa solo esas 4 primeras páginas, ignorando las evidencias.',
      'Resultado: análisis mucho más rápido y menor consumo de tokens cuando se usa la IA con archivos grandes.',
      'Aplica tanto al endpoint /configuracion/extraer-pdf como a /configuracion/extraer-pdf-ia.',
    ],
  },

  // ─── v1.10.6 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.6',
    fecha: '2026-05-15',
    titulo: 'Auto-corregir cuando Google deprecó el modelo configurado',
    tipo: 'fix',
    cambios: [
      'Google retiró el modelo gemini-2.0-flash que IMEC tenía como default y la prueba de conexión devolvía HTTP 404.',
      'El default ahora es gemini-flash-latest, alias que Google mantiene siempre apuntando al Flash más reciente.',
      'Si al probar conexión Google responde 404 "no longer available", IMEC ahora cambia automáticamente al modelo más reciente disponible y reintenta. El resultado muestra un aviso ⚠️ explicando la auto-corrección.',
      'El cron de auto-update también detecta si el modelo actual desapareció de la lista de Google y fuerza el cambio (antes solo cambiaba si había uno con mayor versión).',
    ],
  },

  // ─── v1.10.5 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.5',
    fecha: '2026-05-15',
    titulo: 'Conexión con Gemini ya funciona (faltaba import de httpx)',
    tipo: 'fix',
    cambios: [
      'Las llamadas a Google Gemini (Probar conexión, listar modelos, auto-update) fallaban con un NameError porque el módulo httpx, que ya estaba en requirements.txt, no se había importado en el backend.',
      'Importado httpx al inicio de server.py.',
      'Las API keys que se guardaron en intentos anteriores ya están bien cifradas y siguen siendo válidas: ahora la app ya puede usarlas.',
    ],
  },

  // ─── v1.10.4 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.4',
    fecha: '2026-05-15',
    titulo: 'Compatibilidad con SECRET_KEY corta al guardar la API key',
    tipo: 'fix',
    cambios: [
      'El cifrado exigía una SECRET_KEY de al menos 16 caracteres y bloqueaba el guardado cuando la variable de Railway era más corta.',
      'Ahora se confía en scrypt, que está diseñado precisamente para fortalecer claves cortas. No hay longitud mínima.',
      'Si no hay CONFIG_ENCRYPTION_KEY, se usa la SECRET_KEY del módulo (que ya tiene fallback automático a un token de 64 chars).',
    ],
  },

  // ─── v1.10.3 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.3',
    fecha: '2026-05-15',
    titulo: 'Guardar API key de Gemini ya no falla con "Error de conexión"',
    tipo: 'fix',
    cambios: [
      'Al guardar la API key, la derivación scrypt se ejecutaba en cada cifrado y podía tardar varios segundos en Railway, lo que disparaba un timeout que el frontend reportaba como "Error de conexión".',
      'Ahora la instancia de cifrado se calcula una sola vez por proceso y se cachea: el primer PATCH es instantáneo.',
      'La instancia se pre-calienta al arrancar el servidor para que el primer guardado no espere nada.',
      'Endpoint /system-config robustecido con manejo de errores explícito y logging detallado.',
    ],
  },

  // ─── v1.10.2 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.2',
    fecha: '2026-05-15',
    titulo: 'Modelos de Gemini 2.5, 3.0 y posteriores ahora visibles',
    tipo: 'fix',
    cambios: [
      'El filtro de modelos disponibles era demasiado estricto: excluía "preview", "experimental" y "thinking", que es justo donde Google publica primero los modelos nuevos (2.5, 3.0, 3.5...).',
      'Ahora el selector muestra todos los modelos Gemini Flash de texto, incluyendo los más recientes en preview.',
      'Los modelos GA (estables) aparecen antes de los preview/experimental dentro de la misma versión.',
      'Labels más limpios: por ejemplo "Gemini 2.5 Flash" y "Gemini 3.0 Flash (preview)" en vez de los IDs largos de Google.',
      'Soporte del alias "gemini-flash-latest" si Google lo expone.',
    ],
  },

  // ─── v1.10.1 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.1',
    fecha: '2026-05-15',
    titulo: 'Auto-actualización diaria del modelo de Gemini',
    tipo: 'feat',
    cambios: [
      'IMEC ahora verifica diariamente si Google publicó un Gemini Flash más reciente y lo selecciona automáticamente.',
      'El modelo más nuevo aparece en el selector con la etiqueta "Latest (recomendado)".',
      'Bajo el selector se muestra la fecha de la última verificación y, si hubo cambio, qué modelo se reemplazó.',
      'El botón "🔄 Buscar actualizaciones" ahora ejecuta el chequeo manual contra Google en lugar de solo recargar la lista.',
      'Cron interno con asyncio que corre cada 6 horas y ejecuta el chequeo si han pasado más de 23 horas desde el último.',
    ],
  },

  // ─── v1.10.0 ──────────────────────────────────────────────────────────────
  {
    version: '1.10.0',
    fecha: '2026-05-15',
    titulo: 'Sistema (IA) — integración con Google Gemini',
    tipo: 'feat',
    cambios: [
      'Nueva pestaña "🤖 Sistema (IA)" en Configuración (solo administradores).',
      'Configurar API Key de Google AI Studio (se guarda CIFRADA en la base de datos con AES-128 + HMAC).',
      'Selector de modelo Gemini con búsqueda en vivo de los modelos Flash disponibles para tu API key.',
      'Botón "Probar conexión" que hace una llamada real a Gemini para verificar que la key funciona.',
      'Tabla "Todas las configuraciones del sistema" con vista de las claves, valores cifrados y descripciones.',
      'En el modal de "Importar desde PDF", nuevo botón "✨ Mejorar con IA" que aparece cuando el parser heurístico deja campos vacíos: usa Gemini para releer el PDF y completar lo que falta.',
    ],
  },

  // ─── v1.9.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.9.0',
    fecha: '2026-05-15',
    titulo: 'Importar datos desde un PDF existente',
    tipo: 'feat',
    cambios: [
      'Nuevo botón "📄 Importar desde PDF" en Configuración.',
      'Sube un PDF de cuenta de cobro o GC y la app extrae automáticamente: nombre, cédula, lugar de expedición, datos del supervisor, número de contrato, objeto, valor/forma de pago, plazo y la lista de obligaciones.',
      'Un modal muestra todo lo extraído, te permite editar o desmarcar campos antes de aplicar.',
      'Puedes elegir: sobreescribir los datos actuales o solo rellenar los campos vacíos.',
      'Funciona con PDFs del formato GCCON-F-087 V2 y también con cuentas hechas manualmente que mantengan etiquetas similares.',
    ],
  },
  {
    version: '1.9.0',
    fecha: '2026-05-15',
    titulo: 'Firma con fondo transparente automática',
    tipo: 'feat',
    cambios: [
      'La firma del contratista ahora acepta JPG además de PNG.',
      'Al subir una imagen sobre fondo blanco, el sistema le quita el fondo automáticamente y la guarda como PNG con transparencia.',
      'Si el resultado no quedó perfecto, hay un enlace a remove.bg para procesarla manualmente.',
      'La vista previa de la firma ahora muestra un patrón de cuadros para confirmar visualmente que el fondo es transparente.',
    ],
  },

  // ─── v1.8.1 ───────────────────────────────────────────────────────────────
  {
    version: '1.8.1',
    fecha: '2026-05-15',
    titulo: 'El check de descripción ya no borra el texto al desactivarse',
    tipo: 'fix',
    cambios: [
      'Al desmarcar "Agregar descripción / ayuda para evidencias" el texto ya no se borra: solo se oculta.',
      'Al volver a marcar el check, el texto guardado reaparece y se puede editar.',
      'El estado del check ahora se guarda: una descripción desactivada no aparece en las cuentas ni post cuentas.',
    ],
  },

  // ─── v1.8.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.8.0',
    fecha: '2026-05-15',
    titulo: 'Mover evidencias entre obligaciones',
    tipo: 'feat',
    cambios: [
      'Cada evidencia tiene un nuevo botón "📦 Mover a otra obligación".',
      'Al hacer clic se abre un modal para elegir la obligación de destino.',
      'La evidencia se traslada completa (imagen y descripción) a la obligación seleccionada.',
      'Disponible tanto al crear como al editar cuentas de cobro y post cuentas.',
    ],
  },

  // ─── v1.7.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.7.0',
    fecha: '2026-05-15',
    titulo: 'Sincronización de obligaciones al editar documentos antiguos',
    tipo: 'feat',
    cambios: [
      'Al abrir a editar una cuenta de cobro o post cuenta creada antes de modificar las obligaciones en Configuración, la app detecta las diferencias.',
      'Aparece un modal que informa de obligaciones nuevas, con título modificado o eliminadas de la configuración.',
      'El usuario decide si quitar las obligaciones eliminadas y si conservar o borrar las evidencias de las obligaciones modificadas.',
      'El modal solo aparece cuando realmente hay cambios; si nada cambió, el editor abre directo.',
    ],
  },
  {
    version: '1.7.0',
    fecha: '2026-05-15',
    titulo: 'Campo "Descripción / Ayuda" de obligaciones ahora es opcional',
    tipo: 'ui',
    cambios: [
      'En Configuración, el campo de descripción/ayuda de cada obligación está oculto por defecto.',
      'Se activa con un checkbox "Agregar descripción / ayuda para evidencias".',
      'Si la obligación ya tiene descripción (por ejemplo, cargada de una plantilla), el campo se muestra automáticamente.',
    ],
  },

  // ─── v1.6.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.6.0',
    fecha: '2026-05-15',
    titulo: 'Versionado de la app y bitácora de cambios',
    tipo: 'feat',
    cambios: [
      'La aplicación ahora usa versionado SemVer (MAJOR.MINOR.PATCH), visible para todos junto al logo IMEC.',
      'Nueva página de Bitácora (solo para administradores) con el historial completo de versiones y cambios agrupados.',
      'Al hacer clic en la versión del header (solo admin), se abre un modal con las novedades de la versión actual.',
      'La versión también aparece en la pantalla de inicio de sesión.',
    ],
  },

  // ─── v1.5.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.5.0',
    fecha: '2026-05-15',
    titulo: 'Toggle de viáticos en cuenta de cobro',
    tipo: 'feat',
    cambios: [
      'Nuevo interruptor "Viáticos / Desplazamientos" en el editor de cuenta de cobro.',
      'Cuando se activa, aparece una tabla editable con columnas: ítem, número de orden de viaje, lugar, fecha inicial y fecha final.',
      'Las fechas se capturan con date picker y se guardan en formato corto ("Mayo 3").',
      'En el PDF y Word generados, la tabla se diligencia con las filas registradas.',
      'Si el toggle queda desactivado, la tabla mantiene el comportamiento histórico con "No aplica".',
    ],
  },

  // ─── v1.4.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.4.0',
    fecha: '2026-05-15',
    titulo: 'Exportación a Word + simplificación de barras + restricción de emails',
    tipo: 'feat',
    cambios: [
      'Tres nuevos botones de exportación a Word desde el Dashboard: GC Word, Evidencias Word, Post Cuenta Word.',
      'El Word incluye logo SENA en todas las páginas, tablas, banners e imágenes embebidas — equivalente al PDF.',
      'Las páginas de edición ahora muestran solo "Guardar Cambios" y "Volver al Dashboard" en la barra superior.',
      'Las acciones de PDF / Word / Email se concentran en las tarjetas del Dashboard.',
      'Los botones de envío por correo en las tarjetas Post Cuenta (PDF Email / ZIP Email) ahora son visibles solo para admin y soporte.',
    ],
  },
  {
    version: '1.4.0',
    fecha: '2026-05-15',
    titulo: 'Idioma Español (Colombia) en los Word generados',
    tipo: 'feat',
    cambios: [
      'Los archivos .docx ahora se marcan internamente como Español (Colombia) — es-CO.',
      'Word aplica el corrector ortográfico colombiano automáticamente al abrirlos.',
      'Se escribe en styles.xml y settings.xml del .docx (themeFontLang).',
    ],
  },

  // ─── v1.3.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.3.0',
    fecha: '2026-05-15',
    titulo: 'Modo mantenimiento con periodo de gracia y autoguardado global',
    tipo: 'feat',
    cambios: [
      'El administrador puede programar mantenimiento con minutos de aviso previo.',
      'Antes del corte, todas las páginas en edición autoguardan automáticamente vía evento global.',
      'Los usuarios reciben aviso y se redirigen a la pantalla de mantenimiento sin perder cambios.',
    ],
  },
  {
    version: '1.3.0',
    fecha: '2026-05-15',
    titulo: 'Header colapsable en páginas de edición',
    tipo: 'ui',
    cambios: [
      'El encabezado superior de las pantallas de edición se puede colapsar para ganar espacio vertical.',
      'Ideal para pantallas pequeñas o cuando se editan muchas obligaciones.',
    ],
  },
  {
    version: '1.3.0',
    fecha: '2026-05-15',
    titulo: 'Zona de evidencias rediseñada',
    tipo: 'ui',
    cambios: [
      'Los botones de carga y captura ahora están dentro del cuadro de evidencias.',
      'Se habilitó arrastrar-y-soltar archivos directamente sobre la zona.',
      'Vista previa visual mejorada para imágenes y PDFs adjuntos.',
    ],
  },
  {
    version: '1.3.0',
    fecha: '2026-05-14',
    titulo: 'Estado "En línea" basado en actividad real',
    tipo: 'fix',
    cambios: [
      'El indicador "En línea" en la gestión de usuarios ya no se queda pegado tras el login.',
      'Ahora refleja actividad reciente del usuario (heartbeat) y se actualiza en tiempo real.',
    ],
  },

  // ─── v1.2.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.2.0',
    fecha: '2026-05-14',
    titulo: 'Botón "Tomar Foto" con cámara y timestamp',
    tipo: 'feat',
    cambios: [
      'Botón dedicado para capturar evidencia desde la cámara del móvil sin salir de la app.',
      'Opción de estampar fecha y hora sobre la foto al momento de tomarla.',
    ],
  },

  // ─── v1.1.0 ───────────────────────────────────────────────────────────────
  {
    version: '1.1.0',
    fecha: '2026-05-14',
    titulo: 'Cargo personalizado y promoción a plantilla',
    tipo: 'feat',
    cambios: [
      'Los usuarios con cargo "Otro" pueden nombrar libremente su cargo en perfil.',
      'El admin ve a TODOS los usuarios "Otro" y puede promover sus obligaciones a una nueva plantilla del catálogo.',
      'Una vez promovida, otros usuarios pueden seleccionar ese cargo desde el dropdown.',
    ],
  },
  {
    version: '1.1.0',
    fecha: '2026-05-14',
    titulo: 'Sub-pestañas en módulo Plantillas',
    tipo: 'ui',
    cambios: [
      'El módulo de Plantillas se divide en dos sub-pestañas: "Cargo" y "Configuración Documento".',
      'Más claro qué se está editando: las obligaciones del cargo o el formato del documento.',
    ],
  },
  {
    version: '1.1.0',
    fecha: '2026-05-14',
    titulo: 'Habeas Data y trazabilidad de aceptación',
    tipo: 'feat',
    cambios: [
      'Modal de tratamiento de datos personales (Habeas Data) en el primer ingreso.',
      'Nueva columna "Habeas Data" en gestión de usuarios para que el admin vea quién aceptó y cuándo.',
    ],
  },

  // ─── v1.0.0 (Versión inicial estable — abril 2026) ────────────────────────
  {
    version: '1.0.0',
    fecha: '2026-05-08',
    titulo: 'Limpieza en el nombre de los PDF',
    tipo: 'fix',
    cambios: [
      'El año dejó de incluirse en el nombre del archivo PDF generado (más limpio y corto).',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-05-05',
    titulo: 'Formato actualizado a GCCON-F-087 V2',
    tipo: 'fix',
    cambios: [
      'Se actualizó la versión del formato del Informe Mensual a GCCON-F-087 V2.',
      'Mejor redacción para obligaciones sin evidencias o acciones en el periodo.',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-20',
    titulo: 'Vista previa de PDF en tarjetas y optimización móvil',
    tipo: 'feat',
    cambios: [
      'Modal de vista previa del PDF directamente desde las tarjetas (GC, PC y Gestión Financiera).',
      'En móvil aparece un botón dedicado "Abrir PDF" para mejor experiencia táctil.',
      'Las descargas reusan el blob ya cargado en el modal (no regenera el PDF).',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-20',
    titulo: 'Almacenamiento persistente y logos correctos',
    tipo: 'fix',
    cambios: [
      'Los PDF generados se guardan en el volumen persistente de Railway (no se pierden en redeploys).',
      'El logo SENA aparece en todas las páginas del Informe GCCON-F-087.',
      'Los usuarios heredan el logo y clasificación de la información del admin (no requiere configurarlo individualmente).',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-13',
    titulo: 'Encabezado institucional en PDF de evidencias',
    tipo: 'fix',
    cambios: [
      'PDF de Solo Evidencias (GOR-F-012) ahora muestra los banners institucionales correctamente.',
      'Tabla de desplazamientos vacía muestra "No aplica" en cada celda.',
      'Nombre del archivo respeta el formato GOR-F-012.',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-11',
    titulo: 'Papelera de usuarios y pestañas de estado',
    tipo: 'feat',
    cambios: [
      'Los usuarios eliminados van a una papelera con opción de restaurar.',
      'Gestión de usuarios con pestañas: Activos / Deshabilitados / Eliminados.',
      'Selector mes-año y rango de fechas en Post Cuentas con MonthYearPicker.',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-10',
    titulo: 'Mejoras en gestión de obligaciones y evidencias',
    tipo: 'feat',
    cambios: [
      'Acordeón exclusivo en obligaciones: solo una abierta a la vez con indicador de "última editada".',
      'Cada obligación muestra fecha y hora de última modificación.',
      'Drag personalizado con auto-scroll al arrastrar evidencias cerca de los bordes.',
      'Fechas de evidencias normalizadas a hora Colombia (UTC-5).',
      'Al bloquear una cuenta, su estado pasa a "completado"; al desbloquear, vuelve a "borrador".',
    ],
  },
  {
    version: '1.0.0',
    fecha: '2026-04-10',
    titulo: 'Selector visual de meses con chips horizontales',
    tipo: 'ui',
    cambios: [
      'Reemplazo del input de texto para meses por un selector visual con pastillas (popup 4x3 compacto).',
      'Formato de planilla incluye automáticamente la preposición "de" (ej. "Marzo de 2026").',
    ],
  },
];

export const COLORES_TIPO = {
  feat:  { label: 'Nuevo',         bg: 'bg-emerald-100', text: 'text-emerald-800', border: 'border-emerald-300' },
  fix:   { label: 'Corrección',    bg: 'bg-amber-100',   text: 'text-amber-800',   border: 'border-amber-300' },
  ui:    { label: 'Visual',        bg: 'bg-blue-100',    text: 'text-blue-800',    border: 'border-blue-300' },
  perf:  { label: 'Rendimiento',   bg: 'bg-purple-100',  text: 'text-purple-800',  border: 'border-purple-300' },
  chore: { label: 'Mantenimiento', bg: 'bg-gray-100',    text: 'text-gray-700',    border: 'border-gray-300' },
};

export const ICONOS_TIPO = {
  feat:  '✨',
  fix:   '🔧',
  ui:    '🎨',
  perf:  '⚡',
  chore: '🛠️',
};
